;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { MembershipDataByTokenMVaultSuccessResponse } from "@/lib/types/api/mvault";

import { PRODUCTION_APP_ENV_STRING } from '@/lib/constants'

/**
 * Whether a membership pk is the seeded dev membership, which activates without
 * touching MVault. Always false in production, whatever pk is passed.
 */
export function isDevMembership(pk: string | number): boolean {
  if(process.env.NODE_ENV === 'development' || process.env.APP_ENV !== PRODUCTION_APP_ENV_STRING) {
    return pk === unactivatedDevMembershipData.pk
  }

  return false
}

export const unactivatedDevMembershipData: MembershipDataByTokenMVaultSuccessResponse = {
  first_name: 'Mr Next',
  last_name: '.js',
  email: 'nextjs@example.com',
  phone: null,
  offer: 'koth-passport-offer',
  notes: '',
  start_date: '2025-05-08T14:49:10Z',
  expire_date: '2032-05-17T14:50:17Z',
  grace_period: '2032-05-20T14:50:17Z',
  membership_id: 'B9324F9-75B5-43E8-ADF1-517D1F303CE7',
  create_date: '2025-05-08T17:52:07Z',
  update_date: '2025-05-08T17:52:07Z',
  activation_date: null,
  status: 'On',
  current_state: {
    has_access: false,
    explanation: {
      status: 'On',
      timing: 'within_start_expire_dates',
      token_activated: false
    }
  },
  provisional: true,
  additional_metadata: '',
  token: 'sherlock-current-heroic-quarter',
  creator: 'aslkdjflakjsdflkjasdf@pbs.org',
  last_modifier: '',
  mvault_id: 'e4362748-d291-4bbf-a403-55730b7bc44e',
  station_call_sign: 'KOTH',
  station_id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb',
  pk: 239486758768,
}
